import { Box, Typography, Paper, Divider } from '@mui/material';
import StatusChip from './StatusChip';
import { getActionableEventCssVars } from '../Utility/calculations';
import {
    handleValidateCodevalue,
    ACTIONABLES_CALENDAR_CARD_BG_OPACITY,
    ACTIONABLES_CALENDAR_CARD_HOVER_OPACITY,
    ACTIONABLES_CALENDAR_NOTE_MAX_LENGTH,
    ACTIONABLE_DETAIL_CARD_I18N_KEYS
} from '../Utility/constant';


const ActionableDetailCard = ({
    item,
    isLead = true,
    internationalise,
    onClick,
    className = '',
    sx={} 
}) => {
    if (!item) return null;

    const raw = item.rawItem || {};
    const cssVars = getActionableEventCssVars(
        item.statusStyle,
        ACTIONABLES_CALENDAR_CARD_BG_OPACITY,
        ACTIONABLES_CALENDAR_CARD_HOVER_OPACITY
    );
    const leadFullName = `${raw.firstName || ''} ${raw.lastName || ''}`.trim();

    const idLabel = handleValidateCodevalue(
        internationalise,
        isLead ? ACTIONABLE_DETAIL_CARD_I18N_KEYS.leadId : ACTIONABLE_DETAIL_CARD_I18N_KEYS.taskId
    );
    const parentTaskIdLabel = handleValidateCodevalue(internationalise, ACTIONABLE_DETAIL_CARD_I18N_KEYS.parentTaskId);
    const leadNameLabel = handleValidateCodevalue(internationalise, ACTIONABLE_DETAIL_CARD_I18N_KEYS.leadName);
    const customerLabel = handleValidateCodevalue(internationalise, ACTIONABLE_DETAIL_CARD_I18N_KEYS.customer);
    const descriptionLabel = handleValidateCodevalue(internationalise, ACTIONABLE_DETAIL_CARD_I18N_KEYS.description);
    const startDateLabel = handleValidateCodevalue(internationalise, ACTIONABLE_DETAIL_CARD_I18N_KEYS.startDate);
    const followupDateLabel = handleValidateCodevalue(internationalise, ACTIONABLE_DETAIL_CARD_I18N_KEYS.followupDate);
    const noteLabel = handleValidateCodevalue(
        internationalise,
        isLead ? ACTIONABLE_DETAIL_CARD_I18N_KEYS.leadNote : ACTIONABLE_DETAIL_CARD_I18N_KEYS.taskNote
    );
    const dealValueLabel = handleValidateCodevalue(internationalise, ACTIONABLE_DETAIL_CARD_I18N_KEYS.dealValue);
    return (
        <Paper
            elevation={0}
            onClick={(e) => {
                if (onClick) {
                    e.stopPropagation();
                    onClick(raw);
                }
            }}
            className={`actionables-calendar__detail-card ${className}`.trim()}
            style={cssVars}
        >
            <Box className="actionables-calendar__detail-card-header">
                <Typography variant="subtitle2" className="actionables-calendar__detail-card-id">
                    {`${idLabel}: ${item.rawId}`}
                </Typography>
                <StatusChip
                    status={item.rawStatus}
                    systemLookup={item.systemLookup}
                    internationalise={internationalise}
                    isLead={isLead}
                />
            </Box>
            <Divider className="actionables-calendar__detail-card-divider" />
            {isLead ? (
                leadFullName && (
                    <Typography variant="caption" className="actionables-calendar__detail-card-detail">
                        <strong className="actionables-calendar__detail-card-label">{leadNameLabel}:</strong> {leadFullName}
                    </Typography>
                )
            ) : (
                <>
                    {raw.parentTaskId && (
                        <Typography variant="caption" className="actionables-calendar__detail-card-detail">
                            <strong className="actionables-calendar__detail-card-label">{parentTaskIdLabel || 'Parent Task ID'}:</strong> {raw.parentTaskId}
                        </Typography>
                    )}
                    {raw.customerName && (
                        <Typography variant="caption" className="actionables-calendar__detail-card-detail">
                            <strong className="actionables-calendar__detail-card-label">{customerLabel}:</strong> {raw.customerName}
                        </Typography>
                    )}
                    {raw.description && (
                        <Typography variant="caption" className="actionables-calendar__detail-card-detail actionables-calendar__detail-card-description">
                            <strong className="actionables-calendar__detail-card-label">{descriptionLabel}:</strong> {raw.description}
                        </Typography>
                    )}
                </>
            )}
            <Typography variant="caption" className="actionables-calendar__detail-card-detail actionables-calendar__detail-card-date">
                <strong className="actionables-calendar__detail-card-label">{startDateLabel}:</strong> {item.startDate}
            </Typography>
            <Typography variant="caption" className="actionables-calendar__detail-card-detail actionables-calendar__detail-card-date">
                <strong className="actionables-calendar__detail-card-label">{followupDateLabel}:</strong> {item.endDate}
            </Typography>
            {raw.latestNote && (
                <Typography variant="caption" className="actionables-calendar__detail-card-detail actionables-calendar__detail-card-note">
                    <strong className="actionables-calendar__detail-card-label">{noteLabel}:</strong> {raw.latestNote.substring(0, ACTIONABLES_CALENDAR_NOTE_MAX_LENGTH)}{raw.latestNote.length > ACTIONABLES_CALENDAR_NOTE_MAX_LENGTH ? '...' : ''}
                </Typography>
            )}
            {raw.totalValue != null && (
                <Typography variant="caption" className="actionables-calendar__detail-card-value">
                    {dealValueLabel}: &#8377;{Number(raw.totalValue).toLocaleString()}
                </Typography>
            )}
        </Paper>
    );
};


export default ActionableDetailCard;
